import { HttpContext, HttpContextToken } from '@angular/common/http';

export const resolveWalkthroughUrlScope = (
  scope: string | undefined,
  url: string,
  leadingSlash = false,
) => (scope === 'walkthrough' ? `onboarding${leadingSlash ? '/' : ''}${url}` : url);

export const HAS_ONBOARDING_ENDPOINT = new HttpContextToken(() => false);

export const getOptions = (options: { hasOnboarding: boolean }) => ({
  httpContext: new HttpContext().set(HAS_ONBOARDING_ENDPOINT, options.hasOnboarding),
});
